module.exports = __webpack_public_path__ + "static/media/sliders-v-square.6c41085f.svg";